import { render, staticRenderFns } from "./ProgressBlock.vue?vue&type=template&id=da91ebf2&scoped=true&"
import script from "./ProgressBlock.vue?vue&type=script&lang=js&"
export * from "./ProgressBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBlock.vue?vue&type=style&index=0&id=da91ebf2&lang=scss&scoped=true&"
import style1 from "./ProgressBlock.vue?vue&type=style&index=1&id=da91ebf2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da91ebf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da91ebf2')) {
      api.createRecord('da91ebf2', component.options)
    } else {
      api.reload('da91ebf2', component.options)
    }
    module.hot.accept("./ProgressBlock.vue?vue&type=template&id=da91ebf2&scoped=true&", function () {
      api.rerender('da91ebf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/ProgressBlock.vue"
export default component.exports